import { useQuery } from '@tanstack/react-query';
import { ProjectAPI } from 'api/project';
import { getProjectSprintsQueryKey, getSprintsForProject } from 'queries/common';
export const useSprints = (projectId, options)=>{
    return useQuery(getProjectSprintsQueryKey(projectId), ()=>ProjectAPI.getSprints(projectId[1]), {
        retry: 1,
        retryOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: typeof (projectId === null || projectId === void 0 ? void 0 : projectId[1]) === 'number',
        cacheTime: 0,
        ...options
    });
};
export const useSprintsOptionsForProject = (projectId, options)=>{
    return useQuery(getSprintsForProject(projectId), ()=>ProjectAPI.getSprintsForProject(projectId[1]), {
        retry: 1,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: typeof (projectId === null || projectId === void 0 ? void 0 : projectId[1]) === 'number',
        ...options
    });
};
